import React, {useState, useEffect, useRef, useContext, Fragment} from "react";
import axios from "axios";
import {useHistory, useParams} from 'react-router-dom'
import Card from "../../../components/Card";
import {Field, Form, Formik} from "formik"
import ModalMsg from "../../../components/ModalMsg";
import * as Yup from "yup";
import {LoaderContext} from "../../../context/LoaderContext";
import {TranslateContext} from "../../../context/TranslateContext";
import LabelErroreCampo from "../../../components/LabelErroreCampo";
import NsFormikScrollToError from "../../../components/NsFormikScrollToError";
import NsBtnBack from "../../../components/buttons/NsBtnBack";

function ModificaTipoMov() {
    const {id} = useParams()

    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {traduci} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    function getTipoMovimento() {
        startChiamata()
        axios
            .get(process.env.REACT_APP_API_ENDPOINT + "/api/rfi/movimento/tipo-movimento/" + id)
            .then((response) => {
                let val = response.data.data;
                setLoadingData(false);

                if (formikRef.current) {
                    formikRef.current.setFieldValue("id_tipo_movimento", val.id_tipo_movimento);
                    formikRef.current.setFieldValue("descrizione", val.descrizione);
                    formikRef.current.setFieldValue("is_prelievo", val.is_prelievo);
                    formikRef.current.setFieldValue("is_versamento", val.is_versamento);
                    formikRef.current.setFieldValue("descr_plur", val.descr_plur);
                    formikRef.current.setFieldValue("sort", val.sort);
                }
                endChiamata()
            });
    }

    useEffect(() => {
        if (loadingData) {
            if (id && id !== '') {
                getTipoMovimento();
            }
        }
    }, [id]);

    const SignupSchema = Yup.object().shape({
        id_tipo_movimento: Yup.string()
            .max(10, traduci('Attenzione! Hai inserito troppi caratteri'))
            .required(traduci('Questo campo è obbligatorio')),
        descrizione: Yup.string()
            .max(50, traduci('Attenzione! Hai inserito troppi caratteri'))
            .required(traduci('Questo campo è obbligatorio')),
        descr_plur: Yup.string()
            .max(50, traduci('Attenzione! Hai inserito troppi caratteri')),
        sort: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
        is_prelievo: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
        is_versamento: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
    });

    return (
        <Card
            icon={'fas fa-exchange-alt'}
            title={id ? 'Modifica Tipo Movimento' : 'Inserisci Tipo Movimento'}
            getBottoniDx={() =>
                <Fragment>
                    <NsBtnBack/>
                    <button type="button" id="salva" name="salva"
                            className="btn btn-card"
                            onClick={() => {
                                if (formikRef.current) {
                                    formikRef.current.handleSubmit()
                                }
                            }}>
                        <i className="fas fa-save"/> Salva
                    </button>
                </Fragment>
            }
        >
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Formik
                initialValues={{
                    id_tipo_movimento: '',
                    descrizione: '',
                    descr_plur: '',
                    is_prelievo: '0',
                    is_versamento: '0',
                    sort: '0'
                }}
                innerRef={formikRef}
                validationSchema={SignupSchema}
                onSubmit={values => {
                    if (id) {
                        startChiamata()
                        axios
                            .put(process.env.REACT_APP_API_ENDPOINT + "/api/rfi/movimento/tipo-movimento/" + id,
                                values)
                            .then((response) => {
                                if (response.data.result === 0) {
                                    endChiamata()
                                    history.goBack();
                                } else {
                                    setModalMsg(response.data.description);
                                    setShow(true);
                                    endChiamata()
                                }
                            });
                    } else {
                        startChiamata()
                        axios
                            .post(process.env.REACT_APP_API_ENDPOINT + "/api/rfi/movimento/tipo-movimento/",
                                values)
                            .then((response) => {
                                if (response.data.result === 0) {
                                    endChiamata()
                                    history.goBack();
                                } else {
                                    setModalMsg(response.data.description);
                                    setShow(true);
                                    endChiamata()
                                }
                            });
                    }
                }}
            >
                {({errors, touched, submitCount, values}) => (
                    <Form className="row g-3">
                        <div className="col-md-12">
                            <label htmlFor="id_tipo_movimento" className="form-label">Codice tipo movimento*:</label>
                            <Field
                                name="id_tipo_movimento"
                                className="form-control"
                                readOnly={id}
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"id_tipo_movimento"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="descrizione" className="form-label">Descrizione conto*:</label>
                            <Field
                                name="descrizione"
                                className="form-control"
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"descrizione"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="descr_plur" className="form-label">Tipo:</label>
                            <Field
                                name="descr_plur"
                                className="form-control"
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"descr_plur"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="is_prelievo" className="form-label">Prelievo:</label>
                            <Field
                                as={"select"}
                                name="is_prelievo"
                                className="form-control form-select"
                                value={values['is_prelievo']}
                                onChange={(event) => {
                                    formikRef.current.setFieldValue("is_prelievo", event.target.value)
                                }}
                            >
                                <option value={''}></option>
                                <option value={'1'}>Sì</option>
                                <option value={'0'}>No</option>
                            </Field>
                            <LabelErroreCampo errors={errors} touched={touched} name={"is_prelievo"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="is_versamento" className="form-label">Versamento:</label>
                            <Field
                                as={"select"}
                                name="is_versamento"
                                className="form-control form-select"
                                value={values['is_versamento']}
                                onChange={(event) => {
                                    formikRef.current.setFieldValue("is_versamento", event.target.value)
                                }}
                            >
                                <option value={''}></option>
                                <option value={'1'}>Sì</option>
                                <option value={'0'}>No</option>
                            </Field>
                            <LabelErroreCampo errors={errors} touched={touched} name={"is_versamento"}
                                              submitCount={submitCount}/>
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="sort" className="form-label">Ordinamento*:</label>
                            <Field
                                name="sort"
                                className="form-control"
                                type={"number"}
                                onWheel={(e) => e.target.blur()} // Prevent default scrolling behavior
                            />
                            <LabelErroreCampo errors={errors} touched={touched} name={"sort"}
                                              submitCount={submitCount}/>
                        </div>

                        <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                    </Form>
                )}
            </Formik>
        </Card>
    );
}

export default ModificaTipoMov;